var ColorsJSON = require('./Colors.json');
export var Colors = ColorsJSON;
//# sourceMappingURL=color.js.map